import { Profile } from "PFTypes";

export const splitTopSkills = (profile: Profile | null | undefined) => {
  const allSkills = profile?.skills || [];
  return [allSkills.filter((skill) => !skill.top), allSkills.filter((skill) => skill.top)] as const;
};

export type SkillsList = ReturnType<typeof splitTopSkills>[0];

export const isSkillsSectionRenderable = (
  ready: boolean,
  profile: Profile | null | undefined,
  skills: SkillsList,
  topSkills: SkillsList
): profile is Profile =>
  Boolean(
    ready && profile && (topSkills.length > 0 || skills.length > 0) && profile.permissionsGroup !== undefined
  );
